<template>
  <!--地址-->
  <div style="position: relative">
    <div class="box">
        <div class="maptitle">地址</div>
        <AutoComplete
            id="ditu"
            v-model="didian"
            placeholder="请输入/选择地址"
            placement="top"
            @on-search="search"
            @on-select="mapSelect"
            class="input"
            :style="{flex:1}"
        >
        <Option v-for="(item,index) in addressList" :value="index" :key="index">{{item.name}}</Option>
        </AutoComplete>
    </div>
    <Alert type="error" show-icon v-if="isShowAlert" style="margin-left:50px;margin-top:10px">请在地址列表中选择或在地图中选择定位!</Alert>
    <div id="container" :style="{height:mapHeight+'px'}"></div>
  </div>
</template>

<script>
  var vm
  var map = null; // 地图对象
  var mark = null; // 地图标点对象
  var autoComplete = null; // 自动搜索填充对象
  var geocoder = ''
  export default {
    name: 'MapSelect',
    props: {
      zuobiao: {
        type: Object,
        default: function () {
          return {
            value: '',
            label: ''
          }
        }
      },
    },
      data() {
        return {
          isShowAlert:false,
          mapHeight:0,
          didian: '',
          addressList: [],
          shequdidian:[],
          alertHeight:32,
          originHeight:0,
        }
      },
    watch:{
      zuobiao () {
        this.didian = this.zuobiao.label
        this.isShowAlert = this.zuobiao.value?false:true
        this.mapHeight = this.originHeight - ( this.zuobiao.value?0:45)
      }
    },
      methods: {
        _initMap() {
            console.log('-------init-map----------')
      console.log(this.zuobiao)
          this.didian = this.zuobiao?this.zuobiao.label:''
          let center_location = []
          let dianstr = this.zuobiao.value || this.$store.state.location
          if (this.zuobiao.value) {
            center_location.push(this.zuobiao.value.split(',')[0])
            center_location.push(this.zuobiao.value.split(',')[1])
          } else if (this.$store.state.location) {
            center_location.push(JSON.parse(this.$store.state.location).x)
            center_location.push(JSON.parse(this.$store.state.location).y)
          }
          console.log(center_location)
          var vm = this
          map = new AMap.Map("container", {
            center: center_location,
            resizeEnable: true,
            zoom:15
          });
          //逆地理编码
          geocoder = new AMap.Geocoder({
            // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
            //city: '010'
          })

          map.plugin('AMap.Geolocation', function () {
            var geolocation = new AMap.Geolocation({
              // 是否使用高精度定位，默认：true
              enableHighAccuracy: true,
              // 设置定位超时时间，默认：无穷大
              timeout: 10000,
              // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
              // buttonOffset: new AMap.Pixel(10, 20),
              //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
              zoomToAccuracy: true,
              //  定位按钮的排放位置,  RB表示右下
              buttonPosition: 'RB'
            })

            /**去掉了getCurrentPosition方法 */

            // map.setCenter(vm.shequdidian)
            var circleMarker = new AMap.CircleMarker({
                  center: vm.shequdidian,
                  radius: 10,//3D视图下，CircleMarker半径不要超过64px
                  strokeColor: '#4685e6',
                  strokeOpacity: 1,
                  fillColor: '#4685e6',
                  fillOpacity: 1,
                  bubble: true,
            })
            circleMarker.setMap(map)
            if (vm.zuobiao.value) {
              console.log('-------vm.zuobiao.value----------')
              console.log(vm.zuobiao.value)
              //map.setCenter([vm.zuobiao.value.split(',')[0],vm.zuobiao.value.split(',')[1]])

                mark = new AMap.Marker({
                  map: map,
                  position: new AMap.LngLat(vm.zuobiao.value.split(',')[0], vm.zuobiao.value.split(',')[1]),
                  icon: new AMap.Icon({
                    size: new AMap.Size(40, 50), //图标大小
                    image: "http://webapi.amap.com/theme/v1.3/markers/n/mark_r.png"
                  })
                });
            }
            AMap.event.addListener(geolocation, 'complete', onComplete)
            AMap.event.addListener(geolocation, 'error', onError)

            function onComplete(data) {
              // data是具体的定位信息
            }

            function onError(data) {
              // 定位出错
            }
          })
          /* 地图点击 清空mark 并创建 新mark */
          map.on("click", function (e) {
            mark && map.remove(mark); // 移出mark点
            var adress = [e.lnglat.getLng(), e.lnglat.getLat()];
            mark = new AMap.Marker({
              map: map,
              position: [e.lnglat.getLng(), e.lnglat.getLat()],
              icon: new AMap.Icon({
                size: new AMap.Size(40, 50), //图标大小
                image: "http://webapi.amap.com/theme/v1.3/markers/n/mark_r.png"
              })
            });
             vm.regeocoder(adress, map);
            /* 绑定mark 的点击事件 */
            // mark.on("click", function (e) {
            //   vm.regeocoder(adress, map);
            // });
          });
          AMap.plugin("AMap.Autocomplete", function () {
            /* Autocomplete 配置参数 */
            var autoOptions = {
              citylimit:true
            };
            autoComplete = new AMap.Autocomplete(autoOptions);
            autoComplete.on("error", function (e) {
              console.log(e);
            });
          });
          this.mapComplete = true
        },
        /* 选择关联数据 */
        mapSelect(val) {
          this.isShowAlert = false
          let cur = this.addressList[val]; // 当前对象
          this.$nextTick(() => {
            this.didian = cur.name; // 更新地点
          })
          this.zuobiao.label = cur.name;
          this.zuobiao.value = `${cur.location.lng},${cur.location.lat}`
          mark && map.remove(mark); // 移出mark点
          mark = new AMap.Marker({
            map: map,
            position: cur.location,
            icon: new AMap.Icon({
              size: new AMap.Size(40, 50), //图标大小
              image: "http://webapi.amap.com/theme/v1.3/markers/n/mark_r.png"
            })
          });

          map.setFitView();
        },
        search(val) {
          if (!this.mapComplete) return
          var vm = this
          this.zuobiao.label = val // 更新用户输入的地点名称 在匹配不到用户输入地点信息时 用户自行填写
          autoComplete.search(val, function (status, res) {
            // 表示有数据
            if (status == "complete") {
              vm.addressList = res.tips;

            } else if (status == "error") {
              console.log(res); // 打印错误状态
            }
          });
        },
        regeocoder(lnglatXY, map) {
          //逆地理编码
          var vm = this;
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: "all"
          });
          geocoder.getAddress(lnglatXY, function (status, result) {
            if (status === "complete" && result.info === "OK") {
              vm.geocoder_CallBack(result, lnglatXY);
            }
          });
          // var marker = new AMap.Marker({
          //   //加点
          //   map: map,
          //   position: lnglatXY
          // });
          // map.setFitView();
        },
        geocoder_CallBack(data, zuobiao) {
          var vm = this;
          var address = data.regeocode.formattedAddress; //返回地址描述
          vm.didian = address;
          vm.zuobiao.value = zuobiao[0] + "," + zuobiao[1];
          vm.zuobiao.label = address;

        },
        add(event) {
          var sp = document.getElementById("container");
          var dituSearch = document.getElementById("ditu");
          if (!sp.contains(event.target) && !dituSearch.contains(event.target)) {

          }
        },
        getZuobiao() {
          return this.zuobiao
        }
      },
      mounted() {
      console.log(this.zuobiao)
        //初始化地图高度
        this.originHeight = window.innerHeight*0.8-51-61-16*2-32-16;
        this.mapHeight = this.originHeight
        //初始化社区地点
        let shequdidian = []
        shequdidian.push(JSON.parse(this.$store.state.location).x)
        shequdidian.push(JSON.parse(this.$store.state.location).y)
        this.shequdidian = shequdidian
        //初始化地图
        this._initMap();

        vm = this
        document.addEventListener("click", vm.add);
      },
      beforeDestroy() {
        document.removeEventListener("click", vm.add)
      }
    }
</script>

<style scoped>
 .maptitle{
     color:#333;
     font-size: 16px;
     line-height: 32px;
     width: 50px;
 }
  #container {
    margin:16px 0 16px 50px;
  }
</style>
